import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationAppResource from './OrganizationAppResource';

class OrganizationSettingAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'organization-setting';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'organizations/settings';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'organizationUuid',
            'disclosures',
            'cashOffers',
            'attomEnabled',
            'upgradeBannerDelay',
            'invitesEnabled',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization: OrganizationAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            disclosures: {
                type: 'boolean',
                presence: true,
            },
            cashOffers: {
                type: 'boolean',
                presence: true,
            },
            attomEnabled: {
                type: 'boolean',
                presence: true,
            },
            upgradeBannerDelay: {
                type: 'integer',
                presence: true,
            },
            invitesEnabled: {
                type: 'boolean',
                presence: true,
            },
        };
    }

    apiPaths (environment = null) {
        return {
            ...super.apiPaths(),
        }
    }
}

export default OrganizationSettingAppResource;
